import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Wichita = () => {
  const nearbyFacilities = [
    { name: 'Aircraft Manufacturing', type: 'Aerospace', capacity: '50+ Facilities' },
    { name: 'Oil Refineries', type: 'Refining', capacity: '150,000 BPD' },
    { name: 'Manufacturing Plants', type: 'Industrial', capacity: '200+ Facilities' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Wichita refineries?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from Wichita oil refineries and manufacturing facilities. We provide 6-8 hour response times with competitive pricing for the Air Capital region."
    },
    {
      question: "What types of equipment do you buy from Wichita aerospace facilities?",
      answer: "We buy industrial process equipment, control valves, instrumentation, and manufacturing equipment from Wichita's extensive aerospace manufacturing facilities. We understand the precision requirements of aerospace-grade equipment."
    },
    {
      question: "How quickly can you respond to Wichita facilities?",
      answer: "We provide 6-8 hour response times for Wichita and surrounding Kansas facilities. Our team has 25+ years of experience serving Wichita's diverse industrial base including aerospace, refining, and manufacturing."
    },
    {
      question: "Do you purchase equipment from Wichita aircraft manufacturing plants?",
      answer: "Yes, we buy process equipment and instrumentation from Wichita's 50+ aircraft manufacturing facilities. We provide professional valuations for aerospace manufacturing equipment and control systems."
    },
    {
      question: "What valve brands do you buy from Wichita facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Rosemount, Emerson, Honeywell, and other major brands from Wichita refineries, aerospace facilities, and manufacturing plants."
    },
    {
      question: "Do you buy equipment during Wichita refinery turnarounds?",
      answer: "Yes, we provide turnaround coordination for Wichita refineries. We can quickly evaluate and purchase surplus equipment during planned shutdowns and maintenance turnarounds."
    }
  ];

  useEffect(() => {
    // Set page title
    document.title = "We Buy Valves Wichita | Industrial Equipment Buyers Wichita Kansas";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves Wichita Kansas - Professional valve buyers serving Kansas aerospace and industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'We buy valves Wichita Kansas - Professional valve buyers serving Kansas aerospace and industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.';
      document.head.appendChild(meta);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'we buy valves wichita, valve buyers Wichita, aerospace equipment Kansas, surplus valves, Fisher control valves, refinery equipment');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'we buy valves wichita, valve buyers Wichita, aerospace equipment Kansas, surplus valves, Fisher control valves, refinery equipment';
      document.head.appendChild(meta);
    }

    // Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/wichita');

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'We Buy Valves Wichita | Industrial Equipment Buyers Wichita Kansas' },
      { property: 'og:description', content: 'We buy valves Wichita Kansas - Professional valve buyers serving Kansas aerospace and industrial facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/wichita' },
      { property: 'og:type', content: 'website' }
    ];

    ogTags.forEach(tag => {
      let meta = document.querySelector(`meta[property="${tag.property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', tag.property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add geo tags
    const geoTags = [
      { name: 'geo.position', content: '37.6872;-97.3301' },
      { name: 'geo.placename', content: 'Wichita, Kansas' },
      { name: 'geo.region', content: 'US-KS' }
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/wichita",
          "url": "https://valvesalessupply.com/wichita",
          "name": "We Buy Valves Wichita | Industrial Equipment Buyers Wichita Kansas",
          "description": "We buy valves Wichita Kansas - Professional valve buyers serving Kansas aerospace and industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Kansas",
                "item": "https://valvesalessupply.com/kansas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Wichita",
                "item": "https://valvesalessupply.com/wichita"
              }
            ]
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Valve Sales Supply - Wichita",
          "image": "https://valvesalessupply.com/logo.png",
          "@id": "https://valvesalessupply.com/wichita",
          "url": "https://valvesalessupply.com/wichita",
          "telephone": "214-854-5638",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Wichita",
            "addressRegion": "KS",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 37.6872,
            "longitude": -97.3301
          },
          "areaServed": {
            "@type": "City",
            "name": "Wichita",
            "containedIn": {
              "@type": "State",
              "name": "Kansas"
            }
          },
          "serviceType": ["Industrial Valve Buyers", "Aerospace Equipment Buyers", "Refinery Equipment", "Manufacturing Equipment"]
        },
        {
          "@type": "FAQPage",
          "mainEntity": faqData.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent === JSON.stringify(schemaData)) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/9ff4cd4c17bbd04fd2773986ead69a11.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">Wichita / We Buy Valves</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Professional <strong>valve buyers in Wichita</strong> serving Kansas aerospace and industrial facilities. 
              Valve Sales Supply purchases surplus valves, control systems, and instrumentation from Wichita manufacturing 
              plants and refineries at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET WICHITA QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">WICHITA INDUSTRIAL EQUIPMENT BUYER</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Wichita is known as the "Air Capital of the World" with extensive aerospace manufacturing alongside 
                oil refining operations. As experienced <strong className="text-[#1B3A5F]">surplus valve buyers in Wichita</strong>, 
                we provide professional equipment purchasing services for all industrial sectors.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We specialize in purchasing <strong className="text-[#1B3A5F]">Fisher control valves</strong>, 
                Rosemount transmitters, and complete instrumentation systems from Wichita industrial facilities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">200+</div>
                  <div className="text-gray-600">Industrial Facilities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">6-8 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">150K</div>
                  <div className="text-gray-600">BPD Capacity</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">WICHITA FACILITIES</h3>
              <div className="space-y-4">
                {nearbyFacilities.map((facility, index) => (
                  <div key={index} className="bg-white rounded-lg p-4">
                    <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                    <div className="flex justify-between mt-2">
                      <span className="text-gray-600 text-sm">{facility.type}</span>
                      <span className="text-[#1B3A5F] font-semibold text-sm">{facility.capacity}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">SELL VALVES WICHITA KS</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from Wichita industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Control Valves',
                equipment: ['Fisher Control Valves', 'Masoneilan Valves', 'Ball Valves', 'Gate Valves', 'Globe Valves'],
                description: 'Premium control valves from Wichita facilities'
              },
              {
                title: 'Process Equipment',
                equipment: ['Heat Exchangers', 'Pumps', 'Compressors', 'Safety Systems'],
                description: 'Industrial equipment from manufacturing plants'
              },
              {
                title: 'Instrumentation',
                equipment: ['Rosemount Transmitters', 'Flow Meters', 'Pressure Instruments', 'Controllers'],
                description: 'Process instrumentation from Kansas facilities'
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300">
                <h3 className="text-[#1B3A5F] text-2xl font-bold mb-4">{category.title}</h3>
                <p className="text-gray-600 mb-6">{category.description}</p>
                
                <div className="space-y-3">
                  {category.equipment.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-center">
                      <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Related Markets */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">RELATED KANSAS MARKETS</h2>
            <p className="text-gray-600 text-xl">We serve all major Kansas industrial centers</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { city: 'Topeka', link: '/topeka' },
              { city: 'Kansas City', link: '/kansas-city' },
              { city: 'Tulsa', link: '/tulsa', state: 'OK' }
            ].map((market, index) => (
              <Link
                key={index}
                to={market.link}
                className="bg-[#F5F7FA] rounded-xl p-6 text-center hover:shadow-lg hover:bg-white transition-all duration-300 border-2 border-transparent hover:border-[#1B3A5F]"
              >
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-2">{market.city}</h3>
                <div className="text-gray-600 text-sm mb-3">{market.state || 'KS'} Valve Buyers</div>
                <div className="text-[#1B3A5F] font-semibold inline-flex items-center">
                  View Details
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/kansas"
              className="text-[#1B3A5F] font-semibold hover:underline inline-flex items-center text-lg"
            >
              View All Kansas Cities
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-bold mb-6">WICHITA EQUIPMENT BUYER</h2>
              <p className="text-xl text-gray-200 mb-8">
                Contact Mark Driver for professional equipment purchasing services in Wichita
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-phone-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold text-xl">214-854-5638</div>
                    <div className="text-gray-300">Direct Line - Mark Driver</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-2xl mr-4"></i>
                  <div>
                    <div className="font-bold">wichita@valvesalessupply.com</div>
                    <div className="text-gray-300">Equipment Lists & Photos</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">WHY CHOOSE VALVE SALES SUPPLY</h3>
              <div className="space-y-4">
                {[
                  'Above scrap rates for functional equipment',
                  'Fast 6-8 hour response in Wichita',
                  'Expert knowledge of industrial equipment',
                  'Professional turnaround coordination',
                  'Complete compliance documentation',
                  '25+ years Kansas market experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] text-xl mr-3"></i>
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <Link
                  to="/contact"
                  className="bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center w-full whitespace-nowrap"
                >
                  GET QUOTE TODAY
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-[#1B3A5F] text-4xl font-bold mb-12 text-center">WICHITA VALVE BUYERS FAQ</h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-xl p-6">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Wichita;
